<app-page-header [heading]="'Credit Note List'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div class="page-panel">
      <div class="row">
        <div class="col-lg-8"></div>
        <div class="col-lg-4">
          <div class="input-group ">
            <input (keydown)="keyDownFunction($event)" [(ngModel)]="search_crd_note" class="form-control"
                  id="typeahead-http"
                  name="search_text" placeholder="Customer Name/ Credit Note No/ Date..." style="height:31px"
                  type="text">
            <div class="input-group-append">
              <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
                <i *ngIf="search_crd_note != ''" class="fa fa-close"></i>
                <i *ngIf="search_crd_note == ''" class="fa fa-search"></i>
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class="clearfix"></div>
        <table class="table tbl table-hover table-striped table-bordered">
            <thead>
                <tr>
                    <th width="1%">#</th>
                    <th width="11%" class="text-left">Credit Note No</th>
                    <th width="10%" class="text-left">Date</th>
                    <th width="10%" class="text-left">Customer</th>
                   <th width="10%" class="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of credit_note_list; let i = index">
                    <td>{{ i+1 }}</td>
                    <td>{{ row.CN_NO}}</td>
                    <td>{{ row.CN_DATE_FORMATTED}}</td>
                    <td>{{ row.CUSTOMER_NAME}}</td>
                   <td class="text-center">
                        <button *ngIf="user_rights.VIEW == '1'" (click)="open(content);getCreditNoteData(row.CN_ID)" alt="View" class="btn btn-xs btn-margin btn-info"
                            style="font-size:10px" title="View"><i class="fa fa-eye"></i></button>&nbsp;&nbsp;
                        <a routerLink="/credit-note/new-credit-note/edit/{{row.CN_ID}}" alt="Edit" class="btn btn-xs btn-margin btn-info" style="font-size:10px;" >
                            <i class="fa fa-edit"></i>
                        </a>&nbsp;&nbsp;
                        <button *ngIf="user_rights.ADD == '1'" (click)="deleteCreditNote(row.CN_ID);" alt="Delete" class="btn btn-xs btn-margin btn-danger"
                            style="font-size:10px" title="Delete"><i class="fa fa-trash"></i></button>&nbsp;&nbsp;
                   </td>
                </tr>
            </tbody>
        </table>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h4 class="modal-title" id="modal-basic-title">
          Credit Note Invoice
      </h4>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn  btn-info btn-sm ng-star-inserted" ngxPrint
              printSectionId="printInvoice" title="Print">
        <i class="fa fa-print"></i>&nbsp;Print&nbsp;
      </button>&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="a4-page">
      <div id="printInvoice">
        <div
          *ngIf="crd_notes"
          style="font-size: 12px; font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';">
          <!--Header-->
          <div style="display:grid;grid-template-columns: 58% 42%;">
            <div style="align-items: center;justify-content: flex-start;display: flex;">
              <ng-container *ngIf="institution.INSTITUTION_LOGO">
                <img alt="institution-logo" width="150" height="150" src="{{logo_path+institution.INSTITUTION_LOGO}}" style="object-fit: contain;display: block;margin-left: 0;width: auto"
                     >
              </ng-container>
            </div>
            <div>
              <ng-container *ngIf="institution">
                <h5 style="font-size: 16px;font-weight: bold;margin: 0">{{ institution.INSTITUTION_NAME }}</h5>
                <div style="font-size: 12px;line-height: 20px;margin-top: 15px">{{ institution.INSTITUTION_ADDRESS }}
                  <br/>
                  {{ institution.INSTITUTION_CITY }},&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }} <br/>
                  Ph:&nbsp;{{ institution.INSTITUTION_PHONE_NO }}<br/>
                  Email :&nbsp;{{ institution.INSTITUTION_EMAIL }}<br/>
                  VAT IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }}
                </div>
              </ng-container>
            </div>
          </div>
          <!-- invoice heading-->
          <div style="font-size: 22px;font-weight: bold;padding: 15px;text-align: center;width: 100%">CREDIT NOTE INVOICE</div>
          <div style="display:grid;grid-template-columns: 58% 42%;">
            <div style="padding-right: 45px;">

              <div style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Customer</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ crd_notes[0].CUSTOMER_NAME }}
                  <ng-container *ngIf="crd_notes[0].CUSTOMER_ADDRESS">,{{ crd_notes[0].CUSTOMER_ADDRESS }}</ng-container>
                  <ng-container *ngIf="crd_notes[0].CUSTOMER_PHONE">,{{ crd_notes[0].CUSTOMER_PHONE }}</ng-container>
                </p>
              </div>

              <div *ngIf="crd_notes[0].VAT_NO" style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">VAT No</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ crd_notes[0].VAT_NO }}</p>
              </div>

            </div>
            <div>
              <div *ngIf="crd_notes[0].CN_NO" style="display: grid;grid-template-columns:32% 3% 65%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Credit Note No</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ crd_notes[0].CN_NO }}</p>
              </div>
              <div *ngIf="crd_notes[0].CN_DATE_FORMATTED"
                   style="display: grid;grid-template-columns:32% 3% 65%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Invoice Date</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ utils.date(crd_notes[0].CN_DATE_FORMATTED) }}</p>
              </div>
            </div>
          </div>

          <table style="width: 100%;border: 1px solid black;margin-top: 40px;border-collapse: collapse;border-radius: 0;">
              <thead>
                <tr style="border: 1px solid  #dee2e6;color: #000;">
                  <th
                    style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;width:1%;">
                    #
                  </th>
                  <th style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;width:10%;">
                    Item
                  </th>
                  <th
                    style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;width:2%;">
                    Quantity
                  </th>
                  <th
                    style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;width:2%;">
                    Rate
                  </th>
                  <th
                    style="padding: 5px !important;font-size: 12px !important;border:1px solid black;width:2%;text-align: right;">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of crd_notes;let i=index" style="border: 1px solid  #dee2e6; ">
                  <td style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: center;">{{ i+1 }}</td>
                  <td style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;"> {{ item.TRADE_NAME }}<br><br><b>Reason:&nbsp;</b>{{item.CND_REASON}}</td>
                  <td style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;"> {{ item.CND_RETURN_QTY }}</td>
                  <td style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;"> {{ item.CND_RETURN_RATE }}</td>
                  <td style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;"> {{ item.CND_RETURN_TOTAL }}</td>
                </tr>
              </tbody>

            </table>

            <table style="width: 100%;border: 0;border-collapse: collapse;border-radius: 0;">
              <tbody>
                <tr style="border-right: 1px solid #343a40;border-left: 1px solid #343a40;border-bottom: 1px solid #343a40;">
                  <td colspan="2" style="padding: 5px !important;font-size: 16px;text-align: right;">
                    <b>Gross Total ({{env.CURRENCY}})&nbsp;&nbsp;:&nbsp;&nbsp;{{ getGrossTotal() | number:'1.2-2' }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
            <!--account details-->
            <div style="display:grid;margin-top: 15px;">
              <p style="margin: 0;font-size: 14px;font-weight: bold">Account details&nbsp;&nbsp;</p>
              <p style="margin: 0;font-size: 14px;line-height: 20px">
                  WFL United General Trading Company,<br>
                  Gulf Bank, 94818570, GULBKWKW,<br>
                KW32GULB0000000000000094818570<br>
              </p>
            </div>
            <!-- footer-->
            <div
              style="font-size: 12px;padding: 15px;text-align: center;width: 100%;position: absolute;bottom: 15px;left: 0;right: 0;">
              This is a computer-generated
              document.
              No signature is required.
            </div>

        </div>
      </div>
    </div>
  </div>
</ng-template>
